import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import FabbisognoPage from "./pages/FabbisognoPage";
import CoperturaPage from "./pages/CoperturaPage";
import FattibilitaPage from "./pages/FattibilitaPage";
import ImpostazioniPage from "./pages/ImpostazioniPage";
import NormativePage from "./pages/normative/NormativePage";
import CostoPersonalePage from "./pages/CostoPersonalePage";
import CostoPersonaleImportPage from "./pages/CostoPersonaleImportPage";
import CostoPersonaleConfrontoPage from "./pages/CostoPersonaleConfrontoPage";
import { Spinner } from "./components/ui/basics";

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner label="Autenticazione…" />
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/fabbisogno" replace />} />
        <Route path="fabbisogno" element={<FabbisognoPage />} />
        <Route path="copertura" element={<CoperturaPage />} />
        <Route path="fattibilita" element={<FattibilitaPage />} />
        <Route path="costo-personale" element={<CostoPersonalePage />} />
        <Route
          path="costo-personale/import"
          element={<CostoPersonaleImportPage />}
        />
        <Route
          path="costo-personale/confronto"
          element={<CostoPersonaleConfrontoPage />}
        />
        <Route path="impostazioni" element={<ImpostazioniPage />} />
        <Route path="normative" element={<NormativePage />} />
        <Route path="*" element={<Navigate to="/fabbisogno" replace />} />
      </Route>
    </Routes>
  );
}
